import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {DateService, MarketZone} from "../services/date.service";

@Pipe({
    name: 'timestampToDate',
    standalone: false
})
export class TimestampToDatePipe implements PipeTransform {
    private translations: any;

    constructor(
        private translateService: TranslateService
    ) { }

    async transform(timestamp: string): Promise<string> {
        if (!timestamp) { return ""; }

        const date = new Date(parseInt(timestamp) * 1000);

        const year = date.getFullYear();
        const day = "0" + date.getDate();
        const hours = date.getHours();
        const minutes = "0" + date.getMinutes();

        const month = await this._getMonth(date.getMonth() + 1);

        return `${year}-${month}-${day.substr(-2)} ${hours}:${minutes.substr(-2)}`;
    }

    private async _getMonth(month: number): Promise<string> {
        if (!this.translations) {
            this.translations = await this.translateService.get('MONTHS').toPromise();
        }
        
        return this.translations[month];
    }
}


@Pipe({
    name: 'questionnaireTimestampToDate',
    standalone: false
})
export class QuestionnaireTimestampToDatePipe implements PipeTransform {

    constructor(private _dateService: DateService) {
    }

    transform(timestamp: number | string, market?: MarketZone, showHour?: boolean, shortVersion?: boolean): string {
        if (!timestamp) {
            return '';
        }

        return this._dateService.convertTimestampToDate(timestamp, market, showHour, shortVersion);
    }
}
